/** @format */

import { useContext } from "react";
import { Context } from "../stores/Provider";
import { setIsLoading } from "../function/setIsLoading";
import { logoutAbnormalFunction } from "../function/logoutAbnormalFunction";

export const ErrorHandler = (navigateByAgent: Function) => {
  const { state, dispatch } = useContext(Context);

  const ErrorHandle = <T extends { code: number; message: string }>(
    response: T,
    normal: Function,
    abnormal: Function,
    userOperate: boolean,
  ) => {
    if (response.code === 0) return;
    //200only
    if (response.code === 200) {
      dispatch({
        type: "set-context-data",
        payload: {
          auth: {
            err_message: "",
            code: response.code,
          },
        },
      });
      normal(response);
      setIsLoading(false, dispatch);
      //400台
    } else if (400 <= response.code && response.code < 500) {
      if (response.code === 401 || response.code === 422) {
        //stateにコードを登録
        dispatch({
          type: "set-context-data",
          payload: {
            auth: {
              err_message: response.message,
              code: response.code,
            },
          },
        });
        if (!userOperate) {
          setIsLoading(false, dispatch);
          return logoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
        }
      }
      abnormal(response);
      setIsLoading(false, dispatch);
    } else {
      setIsLoading(false, dispatch);
      navigateByAgent("/system_error");
    }
  };
  return { ErrorHandle, state };
};
